export default `
  mutation addEnterpriseCustomer($company: String!, $startDate: String!, $expirationDate: String!, $quantity: Int!, $payerUserEmail: String!, $payerUserId: String) {
    addEnterpriseCustomer(company: $company, startDate: $startDate, expirationDate: $expirationDate, quantity: $quantity, payerUserEmail: $payerUserEmail, payerUserId: $payerUserId) {
      success
      message
    }
  }
`
